function moduleFilter(){
	$('.js__filter-dropdown').change(function(){

		var moduleNum 		= $(this).data('current-module');
		var postType  		= $(this).data('current-post');
		
		var filterSetting 	= $('.m__filter-module.module-'+moduleNum+' #filter_module').val();
		var filterType 		= $('.m__filter-module.module-'+moduleNum+' #filter_module').data('filter-type') === 'capacity' ? 'capacity' : postType;
		var taxFilter		= $('.m__filter-module.module-'+moduleNum+' #tax_module').val();

		if($(this).attr('type') == 'radio') {

			if($('.m__filter-module__accredited__locations').length == 0) {

				var filterSetting = $('.m__filter-module.module-'+moduleNum+' .fm__radio-input input:checked').val();
				$('.fm__radio-input').removeClass('checked');
				$(this).parent().addClass('checked');
			}
		}

		if($('.m__filter-module__accredited__locations').length > 0) {
			
			var accreditedFilterSetting = $('.m__filter-module.module-'+moduleNum+' .fm__accredited__radio-input input:checked').val();

			if($(this).attr('type') == 'radio') {
				$('.fm__accredited__radio-input').removeClass('checked');
				$(this).parent().addClass('checked');
			}
		
		} else {
		
			var accreditedFilterSetting = null;
		
		}


		console.log('here3');
		console.log(accreditedFilterSetting);

		 $.ajax({
	        url: '/wp-content/themes/rhubarb-duplo/library/php/fetchPostsForFilter.php',
	        type: 'POST',
	        dataType:'html',
			data: {
				'postType' : postType,
				'filterType' : filterType,
				'setFilter' : filterSetting,
				'taxFilter' : taxFilter,
				'accreditedFilterSetting' : accreditedFilterSetting
			},
	        success: function (data) {

	        	$('.m__filter-module.module-'+moduleNum+' .filter-item').remove(); //Remove all currently displayed posts!

	        	$('.m__filter-module.module-'+moduleNum+' .row').append(data); //Add the new posts in!

	        	$('.m__filter-module .filter-item .filter-item__inner .button').matchHeight();
	        },
	        error: function(xhr, textStatus, errorThrown){
	        	alert('Sorry an error occured. Please check your internet connection.')
		    }
	    });

	})

}